import type { ReactElement } from 'react';
import { useState } from 'react';
import styled, { useTheme } from 'styled-components';

import { Box } from '@hivebrite/design-system/Box';
import { FakeLink } from '@hivebrite/design-system/Link';

import ModalWithTemplate from 'hb-react/shared/components/DesignSystem/Modal/ModalWithTemplate';
import Info from 'hb-react/shared/icons/Info';
import onEnterOrSpacePress from 'hb-react/shared/utils/onEnterOrSpacePress';

const OnlineEventWrapper = () => {
  const [isOpen, setOpen] = useState(false);

  const theme = useTheme();

  return (
    <Box alignItems="center">
      <PointerBox
        aria-label="Online event icon"
        data-testid="webinar-url-details"
        tabIndex={0}
        onKeyPress={onEnterOrSpacePress(() => {
          setOpen(true);
        })}
        onClick={() => {
          setOpen(true);
        }}
        role="button"
      >
        <OnlineEvent colors={theme.colors} />
      </PointerBox>
      {isOpen && (
        <ModalWithTemplate
          onCloseModal={() => {
            setOpen(false);
          }}
          header={
            <OnlineEvent
              title={
                <Box mr={1} font="h3-semibold">
                  {__('Online event')}
                </Box>
              }
              colors={theme.colors}
              iconSize={24}
            />
          }
          width="474px"
          screenReadersCloseButtonText={s__(
            'NetworkEventsAccessibility|Close online event details window',
          )}
        >
          <Box>
            {
              /* prettier-ignore */
              __('You can join this event online. Once you have registered, you will see a countdown that counts down the time until the event starts. When the countdown is over, you will be prompted to join')
            }
          </Box>
        </ModalWithTemplate>
      )}
    </Box>
  );
};

const OnlineEvent = ({
  title = null,
  colors,
  iconSize = 20,
}: {
  title?: ReactElement | null;
  colors: {
    primary: string;
  };
  iconSize?: number;
}) => (
  <>
    {title}
    <Box>
      <Info height={iconSize} width={iconSize} fill={colors.primary} />
    </Box>
  </>
);

const LinkWrapper = ({ webinarUrl }) => {
  const onClick = () => {
    window.open(webinarUrl, '_blank');
  };

  return <LinkBox onClick={onClick}>{webinarUrl}</LinkBox>;
};

const LinkBox = styled(FakeLink)`
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  display: inline-block;
`;

export const EventWebinarUrl = ({
  webinar_url: webinarUrl,
  show_webinar_url: showWebinarUrl = false,
  ml = 2,
  children,
}: {
  webinar_url?: string | null;
  show_webinar_url: boolean;
  ml?: number;
  children?: ReactElement;
}) => {
  if (!webinarUrl) {
    return null;
  }

  return (
    <Box ml={ml} minWidth={0}>
      {children}
      {showWebinarUrl ? (
        <LinkWrapper webinarUrl={webinarUrl} />
      ) : (
        <OnlineEventWrapper />
      )}
    </Box>
  );
};

const PointerBox = styled(Box)`
  cursor: pointer;
`;
